<template>
  <div>
    <div class="bg-glass" >
      <div class="nav-row">
        <router-link to="/home-tab" class="nav-tab" :class="{ active: isActive('/home-tab') }">
          <div class="nav-tab-content">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 12.2039V13.725C22 17.6258 22 19.5763 20.8284 20.7881C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.7881C2 19.5763 2 17.6258 2 13.725V12.2039C2 9.91549 2 8.77128 2.5192 7.82274C3.0384 6.87421 3.98695 6.28551 5.88403 5.10813L7.88403 3.86687C9.88939 2.62229 10.8921 2 12 2C13.1079 2 14.1106 2.62229 16.116 3.86687L18.116 5.10812C20.0131 6.28551 20.9616 6.87421 21.4808 7.82274" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M15 18H9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <span class="nav-label">{{ $t('home') }}</span>
          </div>
        </router-link>

        <router-link to="/message-tab" class="nav-tab" :class="{ active: isActive('/message-tab') }">
          <div class="nav-tab-content">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z" fill="#1C274C"/>
              <path d="M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z" fill="#1C274C"/>
              <path d="M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12Z" fill="#1C274C"/>
              <path d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C21.5093 4.43821 21.8356 5.80655 21.9449 8" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            <span class="nav-label">{{ $t('messenger') }}</span>
          </div>
        </router-link>

        <router-link to="/profile-tab" class="nav-tab" :class="{ active: isActive('/profile-tab') }">
          <div class="nav-tab-content">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="6" r="4" stroke="currentColor" stroke-width="1.5"/>
              <path d="M19.9975 18C20 17.8358 20 17.669 20 17.5C20 15.0147 16.4183 13 12 13C7.58172 13 4 15.0147 4 17.5C4 19.9853 4 22 12 22C14.231 22 15.8398 21.8433 17 21.5634" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <span class="nav-label">{{ $t('profile') }}</span>
          </div>
        </router-link>
      </div>
    </div>

    <div >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    isActive(path) {
      return this.$route && this.$route.path === path
    }
  }
}
</script>

<style scoped>
.bg-glass {
  position: relative;
  background: rgba(255, 255, 255, 0.45) !important;
  -webkit-backdrop-filter: saturate(160%) blur(16px) !important;
  backdrop-filter: saturate(160%) blur(16px) !important;
  border-top: 1px solid rgba(15, 23, 42, 0.10) !important;
  box-shadow: rgba(0, 0, 0, 0.14) 0px -1px 12px !important; /* top shadow */
  border-radius: 16px 16px 0 0;
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
  z-index: 900 !important;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}

.bg-glass::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.05) 100%);
  pointer-events: none;
  border-radius: 16px 16px 0 0;
}

.nav-row {
  display: flex;
}

.nav-tab {
  flex: 1 !important;
  min-width: 0 !important;
  /* padding: 8px 4px !important; */
  /* background: transparent !important; */
  text-decoration: none !important;
}

.nav-tab-content {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 10px 0 !important;
}

.nav-icon, .nav-tab-content svg {
  color: #3c4047 !important;
  transition: all 0.3s ease !important;
  border-radius: 12px !important;
  padding: 8px !important;
}

.nav-tab .nav-tab-content svg path,
.nav-tab .nav-tab-content svg circle,
.nav-tab .nav-tab-content svg rect,
.nav-tab .nav-tab-content svg line,
.nav-tab .nav-tab-content svg polyline,
.nav-tab .nav-tab-content svg polygon {
  stroke: currentColor !important;
  fill: none !important;
}

.nav-label {
  font-size: 11px !important;
  color: #3c4047 !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
  text-align: center !important;
  line-height: 1.2 !important;
  margin-top: 2px !important;
}

.nav-tab.active .nav-tab-content svg, .nav-tab:hover .nav-tab-content svg {
  color: #1c39bb !important;
}
.nav-tab.active .nav-label, .nav-tab:hover .nav-label {
  color: #1c39bb !important;
}

/* bottom nav styles */
</style>


